// Normalize FastAPI error responses (detail can be string or object).
export function errMsg(err, fallback = "Something went wrong") {
  const d = err?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (d && typeof d === "object") {
    if (typeof d.message === "string") return d.message;
    try {
      return JSON.stringify(d);
    } catch {
      /* fall through */
    }
  }
  return err?.message || fallback;
}
